import client from '../client';

export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const FORCE_FORGOT_PASSWORD = 'FORCE_FORGOT_PASSWORD';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const MAKE_USER_MOVEMENT_SPECIALIST = 'MAKE_USER_MOVEMENT_SPECIALIST';
export const UNLOCK_COURSE = 'UNLOCK_COURSE';

export function getAllUsers(query) {
  return {
    type: GET_ALL_USERS,
    promise: client.get('users/all', query),
  };
}

export function makeUserMovementSpecialist(userId) {
  return {
    type: MAKE_USER_MOVEMENT_SPECIALIST,
    promise: client.post(`users/${userId}/make-movement-specialist`),
  };
}

export const forceForgotPassword = (userId, clientId, redirectUri) => {
  return {
    type: FORCE_FORGOT_PASSWORD,
    promise: client.post(`users/${userId}/force-forgot-password`, {
      clientId,
      redirectUri,
    }),
  };
}

export const changeEmail = (userId, email, clientId, redirectUri) => ({
  type: CHANGE_EMAIL,
  promise: client.post(`users/${userId}/email-change`, {
    email,
    clientId,
    redirectUri,
  }),
})

export function unlockCourse(userId, course) {
  return {
    type: UNLOCK_COURSE,
    promise: client.post(`users/${userId}/unlock-course`, { courseId: course.id }),
    course,
    userId,
  };
}



// WEBPACK FOOTER //
// ./src/users/actions.js